export * from './outofstock-product';